import { Flex, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  Bar,
  BarChart,
  CartesianAxis,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import WeeklyEarningChart from "./WeeklyEarningChart";
import MonthlyEarningChart from "./MonthlyEarningChart";
import EarningChart from "./EarningChart";
import WithdrawChart from "./WithdrawChart";
import { useGetState } from "../../context/useGetState";
import axios from "axios";
import { baseURL } from "../../service/api";

const fakeEarningsData = [
  {
    id: 1,
    user_id: "2",
    amount: "2000",
    created_at: "2023-07-08T15:02:11.000000Z",
    updated_at: "2023-07-08T15:02:11.000000Z",
  },
  {
    id: 2,
    user_id: "2",
    amount: "1000",
    created_at: "2023-07-09T15:02:11.000000Z",
    updated_at: "2023-07-09T15:02:11.000000Z",
  },
  {
    id: 3,
    user_id: "2",
    amount: "25000",
    created_at: "2023-08-07T15:02:11.000000Z",
    updated_at: "2023-08-07T15:02:11.000000Z",
  },
  {
    id: 3,
    user_id: "2",
    amount: "2500",
    created_at: "2023-08-10T15:02:11.000000Z",
    updated_at: "2023-08-10T15:02:11.000000Z",
  },
  {
    id: 4,
    user_id: "2",
    amount: "3000",
    created_at: "2023-09-03T15:02:11.000000Z",
    updated_at: "2023-08-12T15:02:11.000000Z",
  },
  {
    id: 5,
    user_id: "2",
    amount: "8000",
    created_at: "2023-09-01T15:02:11.000000Z",
    updated_at: "2023-08-15T15:02:11.000000Z",
  },
  {
    id: 6,
    user_id: "2",
    amount: "4000",
    created_at: "2023-09-02T15:02:11.000000Z",
    updated_at: "2023-08-28T15:02:11.000000Z",
  },
  {
    id: 7,
    user_id: "2",
    amount: "1500",
    created_at: "2023-09-03T15:02:11.000000Z",
    updated_at: "2023-08-29T15:02:11.000000Z",
  },
  {
    id: 8,
    user_id: "2",
    amount: "1500",
    created_at: "2023-09-04T15:02:11.000000Z",
    updated_at: "2023-08-30T15:02:11.000000Z",
  },
  {
    id: 9,
    user_id: "2",
    amount: "25000",
    created_at: "2023-09-05T15:03:11.000000Z",
    updated_at: "2023-09-04T15:03:11.000000Z",
  },
  {
    id: 10,
    user_id: "2",
    amount: "5000",
    created_at: "2023-09-06T15:03:11.000000Z",
    updated_at: "2023-09-06T15:03:11.000000Z",
  },
];

const fakeWithdrawalsData = [
  {
    id: 1,
    user_id: "2",
    amount: "2000",
    created_at: "2023-07-08T15:02:11.000000Z",
    updated_at: "2023-07-08T15:02:11.000000Z",
  },
  {
    id: 2,
    user_id: "2",
    amount: "1000",
    created_at: "2023-07-09T15:02:11.000000Z",
    updated_at: "2023-07-09T15:02:11.000000Z",
  },
  {
    id: 3,
    user_id: "2",
    amount: "2500",
    created_at: "2023-08-10T15:02:11.000000Z",
    updated_at: "2023-08-10T15:02:11.000000Z",
  },
  {
    id: 4,
    user_id: "2",
    amount: "3000",
    created_at: "2023-08-12T15:02:11.000000Z",
    updated_at: "2023-08-12T15:02:11.000000Z",
  },
  {
    id: 5,
    user_id: "2",
    amount: "8000",
    created_at: "2023-08-15T15:02:11.000000Z",
    updated_at: "2023-08-15T15:02:11.000000Z",
  },
  {
    id: 6,
    user_id: "2",
    amount: "4000",
    created_at: "2023-08-28T15:02:11.000000Z",
    updated_at: "2023-08-28T15:02:11.000000Z",
  },
  {
    id: 7,
    user_id: "2",
    amount: "1500",
    created_at: "2023-08-29T15:02:11.000000Z",
    updated_at: "2023-08-29T15:02:11.000000Z",
  },
  {
    id: 8,
    user_id: "2",
    amount: "1500",
    created_at: "2023-08-30T15:02:11.000000Z",
    updated_at: "2023-08-30T15:02:11.000000Z",
  },
  {
    id: 9,
    user_id: "2",
    amount: "2000",
    created_at: "2023-08-30T15:03:11.000000Z",
    updated_at: "2023-08-30T15:03:11.000000Z",
  },
  {
    id: 10,
    user_id: "2",
    amount: "5000",
    created_at: "2023-09-03T15:03:11.000000Z",
    updated_at: "2023-09-03T15:03:11.000000Z",
  },
];

const Earning = () => {
  const { state } = useGetState();
  const userInfo = state?.userInfo;
  console.log(userInfo);
  const dataURL = baseURL + "/" + userInfo?.id;
  const dataURL2 =
    "https://f8.codester.dev/mobile/api/earnings/" + userInfo?.id;
  const [earningsData, setEarningsData] = useState();
  const [active, setActive] = useState("earning");

  let toggleColor = useColorModeValue("#000", "#000");
  let tabBoxShadowColor = useColorModeValue(
    "-1px 20px 15px 0px #80808017",
    "9px 20px 20px 0px #fafafa12"
  );

  const tabstyle = {
    borderRadius: "10px",
    cursor: "pointer",
    boxShadow: tabBoxShadowColor,
    alignItems: "center",
    fontWeight: "100",
    fontSize: ".8em",
  };

  let act = {
    borderRadius: "10px",
    bg: "#0276fc",
    color: "#fff",
  };

  useEffect(() => {
    //setEarningsData(fakeEarningsData)
    const fetchData = async () => {
      // Get the bearer token from sessionStorage
      const token = sessionStorage.getItem("#f8WEB#");
      console.log(token);

      // Define headers with the bearer token
      const headers = {
        Authorization: `Bearer ${token}`,
        // Other headers if needed
      };

      try {
        // Make the Axios call with headers
        const response = await axios.get(dataURL2, { headers });
        //console.log('my_earnings: ',response?.data?.User_earnings);
        setEarningsData(response?.data?.User_earnings);

        // ... Further processing of response
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <Flex
        justifyContent="center"
        alignItems="center"
        style={{ marginBottom: "15px" }}
      >
        <Stack
          direction="row"
          {...tabstyle}
          bg={"#fff"}
          justifyContent="space-between"
          color={toggleColor}
          width="50%"
        >
          <Text
            onClick={() => setActive("earning")}
            p="10px 35px"
            {...(active === "earning" ? act : {})}
            align={"center"}
            width="100%"
          >
            Earnings
          </Text>
          <Text
            onClick={() => setActive("withdraw")}
            p="10px 35px"
            {...(active === "withdraw" ? act : {})}
            align={"center"}
            width="100%"
          >
            Withdraw
          </Text>
        </Stack>
      </Flex>
      {active === "earning" && <EarningChart data={fakeEarningsData} />}
      {active === "withdraw" && (
        <WithdrawChart
          earningsData={fakeEarningsData}
          withdrawalsData={fakeWithdrawalsData}
        />
      )}
    </>
  );
};

export default Earning;
